// extracted by mini-css-extract-plugin
export default {"advantageBlock":"advantageBlock-dQN4t","iconAdvantage":"iconAdvantage-Sjli1","textAdvantage":"textAdvantage-17d7C"};